import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

/**
 * Componente principal (Root) de la aplicación.
 * * El layout de la zona privada (barra lateral, cabecera) vive en `ShellComponent`,
 * por lo que la raíz solo aloja el `RouterOutlet` principal.
 */
@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {}
